interface Props {
  /** Fraction in 0..1. */
  value: number;
  label?: string;
}

export function UploadProgressBar({ value, label = 'Uploading to S3…' }: Props) {
  const pct = Math.round(Math.min(1, Math.max(0, value)) * 100);
  return (
    <div className="space-y-1">
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-bg-subtle">
        <div
          className="h-full rounded-full bg-accent transition-[width]"
          style={{ width: `${pct}%` }}
        />
      </div>
      <div className="flex items-center justify-between text-[10px] font-medium text-fg-subtle">
        <span>{label}</span>
        <span className="font-mono">{pct}%</span>
      </div>
    </div>
  );
}
